import { LoadingSpinner, Stack } from 'components';

import { LastSaved } from '../../noteView/addendumForm/lastSaved';
import { useAutosaveContext } from '../context/autosaveContext';
import style from '../noteEdit.module.scss';

export const AutosaveIndicator = () => {
  const { isAutosaving, lastSaved, enabled } = useAutosaveContext();

  // Don't render anything if autosave is not enabled
  if (!enabled) return null;

  return (
    <div className={style.autosavedBox}>
      <Stack>
        {isAutosaving ? <LoadingSpinner size={30} /> : <LastSaved lastSaved={lastSaved} />}
      </Stack>
    </div>
  );
};
